import React from 'react'
import _ from 'lodash'
import cx from 'classnames'
import styles from './index.css'
import SPBaseModule from '../../../../lib/SPBaseModule'
import { pullLeft, pullRight } from '../../../../styles/shared.css'
import YTable from '../../../Common/YTable'
import Popover from '../../../Common/Popover'
import { numeralFormat, dollarFormat } from '../../../../../lib/renderUtil'
import { getRangeAPIDate, getRangeByTerm } from '../../../../lib/MomentHelper'
import { SaleStatHelper } from '../../../Dashboard/OperatingDashboard/Shared'
import { HyperLink, When } from '../../../Common/Form'
import { formDecorator } from '../../../Common/forms'
import { SELLER_BESTSELLER_FILTER_TYPE_MAP, DEFAULT_BESTSELLER_TERM, EMPTY_VALUE } from '../../../../constants/globalTypes'
import { DEFAULT_DASHBOARD_BESTSELLERS_DATE_RANGE } from '../../../../constants/date'
import { showOnlyNumber } from '../../../../lib/formatter'
import TooltipIcon from '../../../Common/TooltipIcon/TooltipIcon'
import FilledRanking from '../../../Common/FilledRanking/FilledRanking'
import { Icon, Loader, Toast } from '@vzmi/shp_shared_compo'
import BestsellerPagination from '../../../Dashboard/OperatingDashboard/SaleStat/BestsellerPagination/BestsellerPagination'
import RadioGroup from '../../../Common/NewDashboard/RadioGroup/RadioGroup'
import Sort from '../../../Common/NewDashboard/Sort/Sort'
import Block from '../../../Common/NewDashboard/Block/Block'
import SearchForm from '../../../Dashboard/OperatingDashboard/SaleStat/SearchForm/SearchForm'
import { getFormValues } from '../../../Proposal/Common/ProposalForm/Shared/util'
import errorHelper from '../../../../../lib/errorHelper'
import { SELLER_DASHBOARD_ONLINE_DATE } from '../constants'

const SORT_GA_LABEL_MAP = {
  [SELLER_BESTSELLER_FILTER_TYPE_MAP.AMOUNT.type]: 's_topsell_orderamt',
  [SELLER_BESTSELLER_FILTER_TYPE_MAP.QUANTITY.type]: 's_topsell_ordercnt',
  [SELLER_BESTSELLER_FILTER_TYPE_MAP.PAGE_VIEW.type]: 's_topsell_orderpv',
  [SELLER_BESTSELLER_FILTER_TYPE_MAP.CONVERSION_RATE.type]: 's_topsell_ordercvr',
  [SELLER_BESTSELLER_FILTER_TYPE_MAP.UNIQUE_USER.type]: 's_topsell_orderuu'
}

const DAYS_GA_LABEL_MAP = {
  1: 's_topsell_day1',
  7: 's_topsell_day7',
  14: 's_topsell_day14',
  30: 's_topsell_day30'
}

const ITEMS_SORT_GA_LABEL_MAP = {
  [SELLER_BESTSELLER_FILTER_TYPE_MAP.AMOUNT.type]: 's_topsell_list_orderamt',
  [SELLER_BESTSELLER_FILTER_TYPE_MAP.QUANTITY.type]: 's_topsell_list_ordercnt',
  [SELLER_BESTSELLER_FILTER_TYPE_MAP.PAGE_VIEW.type]: 's_topsell_list_orderpv',
  [SELLER_BESTSELLER_FILTER_TYPE_MAP.CONVERSION_RATE.type]: 's_topsell_list_ordercvr',
  [SELLER_BESTSELLER_FILTER_TYPE_MAP.UNIQUE_USER.type]: 's_topsell_list_orderuu'
}

const ITEMS_DAYS_GA_LABEL_MAP = {
  1: 's_topsell_list_day1',
  7: 's_topsell_list_day7',
  14: 's_topsell_list_day14',
  30: 's_topsell_list_day30'
}

const getIsItemsPage = () => {
  if (typeof window === 'undefined') {
    return false
  }
  return window.location.pathname.includes('/seller/items/')
}

export const FIELD = {
  ACTIVE_STATUS: 'activeStatus',
  STOCK_STATUS: 'stockStatus',
  REPORT_DATE: 'reportDate'
}

export const CONFIG = {
  form: 'BESTSELLER_FORM',
  initialValues: {
    [FIELD.ACTIVE_STATUS]: false,
    [FIELD.STOCK_STATUS]: false,
    [FIELD.REPORT_DATE]: DEFAULT_DASHBOARD_BESTSELLERS_DATE_RANGE
  }
}

const customRangeName = '自訂區間'
/**
 * 資料區間選項，前 x 天
 * */
const BESTSELLER_TERM_OPTIONS = [1, 7, 14, 30, customRangeName].map(value => ({
  label: value === customRangeName ? customRangeName : `前${value}天`,
  value
}))

// Bestseller Table 每一 row 需要的 column key name
const BESTSELLER_COLUMN_KEYS = [
  'ranking',
  'listingId',
  'name',
  'soldAmount',
  'soldQuantity',
  'trend',
  'pageView',
  'uniqueUser',
  'conversionRate',
  'availableQuantity',
  'price',
  'sku',
  'skuSubStationId',
  'shipType'
]

/**
 *  獲得打 Bestsellers API 需要的 sort
 *
 * @param {String} sortType
 * @returns {String}
 */
const getSort = sortType => {
  const { key: sortTypeKey } = SELLER_BESTSELLER_FILTER_TYPE_MAP[sortType]
  return `-${sortTypeKey}`
}

/**
 * 獲得某 sortType, term, page 下的 Table 資料
 * 如果有被 cache 在 state cache 裡時的 key
 *
 * @param {Object} params
 * @returns {String}
 */
const getCacheKey = params => {
  const {
    sortType,
    term,
    page,
    isExport = false,
    isZeroStock,
    isActive,
    reportDate = ''
  } = params

  return `${sortType}_${term}_${page}_${isExport}_${isZeroStock}_${isActive}_${reportDate}`
}

const extractAnchor = hash => {
  const sortPattern = Object.values(SELLER_BESTSELLER_FILTER_TYPE_MAP)
    .map(wrapper => wrapper.type)
    .join('|')
  const termPattern = BESTSELLER_TERM_OPTIONS
    .map(({ value }) => value)
    .join('|')
  const match = RegExp(`^#(${sortPattern})_(${termPattern})_(\\d)$`).exec(hash)
  return match
    ? {
      sortType: match[1],
      term: Number(match[2]),
      page: Number(match[3])
    }
    : {}
}

/**
 * 熱銷排行 Main Class Component
 * */
class Bestseller extends SPBaseModule {
  constructor (props) {
    super(props)

    this.state = {
      page: 1,
      term: DEFAULT_BESTSELLER_TERM,
      periodText: '',
      sortType: SELLER_BESTSELLER_FILTER_TYPE_MAP.AMOUNT.type,
      columns: this.generateTableColumns(),
      data: [],
      periodSegment: {},
      useSearch: false,
      changeCustomTab: false,
      customRange: DEFAULT_DASHBOARD_BESTSELLERS_DATE_RANGE
    }
    this.searchFormProps = null
  }

  getStockFormValues = () => {
    const { reduxFormState } = this.props
    const formValues = getFormValues(reduxFormState)
    const { stockStatus } = formValues
    return stockStatus
  }

  getActiveFormValues = () => {
    const { reduxFormState } = this.props
    const formValues = getFormValues(reduxFormState)
    const { activeStatus } = formValues
    return activeStatus
  }

  componentDidMount () {
    const applyAnchor = new Promise(
      (resolve, reject) => {
        const anchor = extractAnchor(this.props.locationHash)
        if (_.isEmpty(anchor)) {
          return resolve()
        }
        this.setState(anchor, resolve)
        console.log('redux form 外觸發 submit...', anchor)
        // 在 redux form 外觸發 submit
        this.searchFormProps.handleSubmit(this.onSearch)()
      })

    applyAnchor.then(this.setCurrentTableData)
  }

  setSearchFormProps = formProps => (this.searchFormProps = formProps)

  onSearch = values => this.loading(async () => {
    const { reduxFormState } = this.props
    const { customRange } = this.state
    const formValues = getFormValues(reduxFormState)
    const { reportDate } = formValues
    const stockStatus = this.getStockFormValues()
    const activeStatus = this.getActiveFormValues()
    // formatDate是call api，payload裡的reportDate
    // reportDate：當前日期(起)/當前日期(迄) 這邊帶+8時區
    // 範例：'2022-11-09T00:00:00+08:00/2022-12-08T23:59:59+08:00'
    const formatDate = getRangeAPIDate(reportDate || customRange)
    const {
      sortType,
      page
    } = this.state

    const apiPayloadObj = {
      page,
      term: DEFAULT_BESTSELLER_TERM,
      sortType,
      reportDate: formatDate,
      ...(stockStatus && { stock: 0 }),
      ...(activeStatus && { isActive: true })
    }
    this.setState(
      () => ({ useSearch: true, customRange: reportDate || customRange }),
      () => {
        this.getSpecificPaginationBestsellers(apiPayloadObj)
          .then(formattedData => {
            this.setCacheData(formattedData)
            /** set up success state */
            this.setIsSuccess(true)
          })
      }
    )
  })

  onPageChange = targetPage => {
    const { page } = this.state
    if (targetPage !== page) {
      this.setState(
        () => ({ page: targetPage }),
        () => this.setCurrentTableData()
      )
    }
  }

  onTermRadioChange = e => {
    const value = _.get(e, 'target.value', '')
    if (value) {
      this.onBestsellerTermChange(value)
    }
  }

  onBestsellerTermChange = (term) => {
    const { onGaClick } = this.props
    const { useSearch } = this.state
    let newterm = term
    // 切換到自訂區間
    const isCustomTab = (newterm === customRangeName)
    if (isCustomTab && !useSearch) {
      newterm = 30
    }
    const isItemsPage = getIsItemsPage()
    const daysMap = isItemsPage ? ITEMS_DAYS_GA_LABEL_MAP : DAYS_GA_LABEL_MAP
    const customLabel = isItemsPage ? 's_topsell_list_dayCustom' : 's_topsell_dayCustom'
    const gaLabel = isCustomTab
      ? customLabel
      : _.get(daysMap, term)
    if (gaLabel) {
      onGaClick(gaLabel)
    }

    this.setState(
      () => ({ term: newterm, changeCustomTab: isCustomTab }),
      () => this.setCurrentTableData())
  }

  // 資料放回 state
  setCacheData = (data) => {
    this.setState(
      () => ({ ...data }),
      () => {
        const { withPagination } = this.props
        const stockStatus = this.getStockFormValues()
        const activeStatus = this.getActiveFormValues()
        if (withPagination) {
          const {
            sortType,
            term,
            page,
            changeCustomTab
          } = this.state

          const getCacheKeyObj = {
            sortType,
            term,
            page,
            isZeroStock: stockStatus,
            isActive: activeStatus
          }
          if (changeCustomTab) {
            getCacheKeyObj.term = customRangeName
          }
          const cacheKey = getCacheKey(getCacheKeyObj)
          window.location.hash = cacheKey
        }

        this.props.postSetCacheData && this.props.postSetCacheData(data)
      }
    )
  }

  /**
   * 由 cache key 取得 cacheData
   */
  getSpecificCacheData = params => {
    const cacheKey = getCacheKey({
      ...params
    })

    const cacheData = this.getStateCache(cacheKey)

    return _.isEmpty(cacheData)
      ? null
      : cacheData
  }

  /**
   * 假設 “轉換率” 沒有資料(或null) , 就顯示 --
   *
   * 假設 '瀏覽量' 為 0, “轉換率” 就顯示 --
   *
   * 假設 是金額相關欄位沒有資料(或null)，顯示 $0
   *
   * 假設 是在其他欄位沒有資料(或null), 就顯示 0
   */
  getFormattedBestsellers = (dataFromAPI, page, rowLimit) => {
    const {
      pagination = {},
      periodSegment = {},
      bestseller = []
    } = dataFromAPI

    const periodText = _.isEmpty(periodSegment)
      ? this.state.periodText
      : SaleStatHelper.formatPeriodSegmentWithYear(periodSegment)

    const rankingBase = (page - 1) * rowLimit

    const formattedBestseller = bestseller
      .map((rowData, rowIndex) => {
        const formattedRowData = {}

        BESTSELLER_COLUMN_KEYS.forEach(columnKey => {
          const originalColumnValue = rowData[columnKey]
          let columnValue = originalColumnValue

          switch (columnKey) {
            case 'ranking': {
              columnValue = rankingBase + (rowIndex + 1)
              break
            }
            case 'price':
            case 'soldAmount': {
              if (_.isNil(originalColumnValue)) {
                columnValue = EMPTY_VALUE
              } else {
                columnValue = dollarFormat(showOnlyNumber(originalColumnValue))
              }
              break
            }
            case 'availableQuantity':
            case 'pageView':
            case 'uniqueUser':
            case 'soldQuantity': {
              if (_.isNil(originalColumnValue)) {
                columnValue = EMPTY_VALUE
              } else {
                columnValue = numeralFormat(originalColumnValue, { allowZero: true })
              }
              break
            }
            case 'conversionRate': {
              if (rowData.pageView === 0) {
                columnValue = EMPTY_VALUE
              } else {
                columnValue = _.isNil(originalColumnValue)
                  ? EMPTY_VALUE
                  : (originalColumnValue * 100).toFixed(2)
              }
              break
            }
            default: {
              break
            }
          }

          formattedRowData[columnKey] = columnValue
        })

        return formattedRowData
      })

    return {
      data: formattedBestseller,
      pagination,
      periodText,
      periodSegment
    }
  }

  /**
   * 去取特定頁數的 PaginationBestsellers，
   * 成功取得後會放入 cache 中
   */
  getSpecificPaginationBestsellers = async params => {
    const {
      page,
      term,
      sortType,
      reportDate,
      stock,
      isExport = false,
      isActive
    } = params

    const {
      useSearch,
      changeCustomTab
    } = this.state

    const {
      rowLimit = 5,
      actions: {
        fetchSePaginationBestsellers
      }
    } = this.props
    const stockStatus = this.getStockFormValues()
    const activeStatus = this.getActiveFormValues()

    const currentLimit = isExport ? 50 : rowLimit

    const sort = getSort(sortType)

    const offset = (page - 1) * currentLimit

    const paginationBestsellersPromise = this.promiseStateWrapper(
      fetchSePaginationBestsellers({
        limit: currentLimit,
        offset,
        sort,
        term,
        reportDate,
        stock,
        isActive
      }))
      .then(res => {
        const {
          error = false,
          payload = {}
        } = res

        if (error) {
          const error = _.get(payload, 'errorData.error[0]')
          const errorMessage = errorHelper.parseErrorMessage(error)
          Toast.error(errorMessage)
          this.setState({ term: customRangeName })
          this.setIsError(false)
          return {}
        }

        if (!error) {
          const {
            bestsellers,
            pagination,
            reportDateStart,
            reportDateEnd
          } = payload
          const periodSegment = (reportDateStart && reportDateEnd)
            ? { start: reportDateStart, end: reportDateEnd }
            : {}

          const formattedStats = this.getFormattedBestsellers({
            bestseller: bestsellers,
            periodSegment,
            pagination
          }, page, currentLimit)
          let newTerm = term

          if (changeCustomTab && useSearch) {
            newTerm = customRangeName
          }
          const getCacheKeyObj = {
            sortType,
            term: newTerm,
            page,
            isExport,
            isZeroStock: stockStatus,
            isActive: activeStatus
          }
          const cacheKey = getCacheKey(getCacheKeyObj)
          this.setStateCache(cacheKey, formattedStats)

          return formattedStats
        }
      })

    return paginationBestsellersPromise
  }

  /**
   * 用目前 state 裡的 term, sort, page 向 API 拿取資料，
   * 拿到後會放入 cache, 同時也放到 state 裡
   */
  setCurrentTableData = async () => {
    const {
      sortType,
      term,
      page,
      changeCustomTab,
      useSearch,
      customRange
    } = this.state
    const stockStatus = this.getStockFormValues()
    const activeStatus = this.getActiveFormValues()
    const formatDate = changeCustomTab
      ? getRangeAPIDate(customRange)
      : getRangeAPIDate(getRangeByTerm(term))
    const cacheDataObj = {
      sortType,
      term,
      page,
      isZeroStock: stockStatus,
      isActive: activeStatus
    }
    if (changeCustomTab && useSearch) {
      cacheDataObj.term = customRangeName
    }
    const cacheData = this.getSpecificCacheData(cacheDataObj)
    if (cacheData) {
      this.setCacheData(cacheData)
      return
    }

    const apiPayloadObj = {
      page,
      sortType,
      reportDate: formatDate, // term 只有購中使用，se 一率轉成 reportDate
      ...(stockStatus && { stock: 0 }),
      ...(activeStatus && { isActive: true })
    }

    this.getSpecificPaginationBestsellers(apiPayloadObj)
      .then(formattedData => {
        this.setCacheData(formattedData)
        /** set up success state */
        this.setIsSuccess(true)
      })
  }

  /**
   * Generate column of react table
   */
  generateTableColumns = () => {
    const buyGdSale = '//tw.buy.yahoo.com/gdsale/gdsale.asp?gdid='
    const columns = [
      {
        /** 排行 */
        id: 'ranking',
        accessor: 'ranking',

        headerClassName: cx(pullLeft, styles.termHeader),
        className: cx(pullLeft, styles.termHeader),
        width: 30,

        Header: () => (
          <div>
            <Popover
              content={`近${this.state.term}天之熱銷賣場; 可依"訂購金額"或"訂購量"進行排序，其中"訂購金額"使用"訂購成本"進行統計`}
            >
              <div>排行</div>
            </Popover>
          </div>
        ),
        Cell: row => {
          const { value } = row
          const filled = value <= 5
          return (
            <FilledRanking
              filled={filled}
              value={value}
            />
          )
        }
      },
      {
        /** 賣場編號 賣場名稱 */
        id: 'listingAndName',
        accessor: rowData => _.pick(rowData, ['listingId', 'name']),

        headerClassName: cx(pullLeft, styles.listingAndNameCol),
        className: cx(pullLeft, styles.listingAndNameCol),

        Header: () => (
          <>
            賣場編號
            <br />
            賣場名稱
          </>
        ),
        Cell: row => {
          const {
            value: {
              listingId,
              name
            }
          } = row

          return (
            <>
              <p className={styles.listingId}>
                <HyperLink
                  target='_blank'
                  href={`${buyGdSale}${listingId}`}
                >
                  {listingId}
                </HyperLink>
              </p>
              <p
                className={styles.listingName}
              >
                {name}
              </p>
            </>

          )
        }
      },
      {
        /** 訂購金額 */
        id: 'soldAmount',
        accessor: 'soldAmount',
        Header: '訂購金額',
        width: 120,

        headerClassName: cx(pullRight, styles.col),
        className: cx(pullRight, styles.col),

        Cell: row => (
          <span>{row.value}</span>
        )
      },
      {
        /** 訂購量 */
        id: 'soldQuantity',
        accessor: 'soldQuantity',
        Header: '訂購量',

        headerClassName: cx(pullRight, styles.col),
        className: cx(pullRight, styles.col),
        width: 60,

        Cell: row => (
          <span>{row.value}</span>
        )
      },
      {
        /** 瀏覽量 */
        id: 'pageView',
        accessor: 'pageView',

        headerClassName: cx(pullRight, styles.col),
        className: cx(pullRight, styles.col),
        width: 100,

        Header: () => (
          <>
            瀏覽量
            <TooltipIcon
              tooltipTitle='賣場被點開的次數'
            />
          </>
        ),
        Cell: row => (
          <span>{row.value}</span>
        )
      },
      {
        /** 轉換率 */
        id: 'conversionRate',
        accessor: 'conversionRate',

        headerClassName: cx(pullRight, styles.col),
        className: cx(pullRight, styles.col),
        width: 100,

        Header: () => (
          <>
            轉換率(%)
            <TooltipIcon
              tooltipTitle='訂購量/瀏覽量(%)'
            />
          </>
        ),
        Cell: row => row.value
      },
      {
        /** 訪客數 */
        id: 'uniqueUser',
        accessor: 'uniqueUser',

        headerClassName: cx(pullRight, styles.col),
        className: cx(pullRight, styles.col),
        width: 100,

        Header: () => (
          <>
            訪客數
            <TooltipIcon
              tooltipTitle='區間訪客為單日不重複訪客數加總'
            />
          </>
        ),
        Cell: row => (
          <span>{row.value}</span>
        )
      },
      {
        /** 可訂購量 */
        id: 'availableQuantity',
        accessor: 'availableQuantity',
        Header: '可訂購量',

        headerClassName: cx(pullRight, styles.col),
        className: cx(pullRight, styles.col),
        width: 70,

        Cell: row => row.value
      },
      {
        /** 目前售價 */
        id: 'price',
        accessor: 'price',
        Header: '目前售價',

        headerClassName: cx(pullRight, styles.col, styles.lastCol),
        className: cx(pullRight, styles.col, styles.lastCol),
        width: 70,

        Cell: row => row.value
      }
    ]
    return columns
  }

  generateSortByRadio = () => {
    const { sortType } = this.state
    const options = Object.values(SELLER_BESTSELLER_FILTER_TYPE_MAP)
      .map(wrapper => ({
        text: wrapper.text,
        value: wrapper.type
      }))
    return (
      <Sort
        id='saleStat-bestseller-tab'
        sortType={sortType}
        options={options}
        onChange={this.onTabChange}
        margin={false}
      />
    )
  }

  onTabChange = (e) => {
    const { sortType } = this.state
    const nextSortType = e.target.value
    if (sortType !== nextSortType) {
      const { onGaClick } = this.props
      const isItemsPage = getIsItemsPage()
      const sortMap = isItemsPage ? ITEMS_SORT_GA_LABEL_MAP : SORT_GA_LABEL_MAP
      const gaLabel = _.get(sortMap, nextSortType)
      if (gaLabel) {
        onGaClick(gaLabel)
      }
      this.setState(
        () => ({
          sortType: nextSortType
        }),
        () => {
          this.setCurrentTableData()
        })
    }
  }

  /**
   * 供匯出功能使用，
   * 取得目前 term, sort 之下的所有資料，
   * cache 裡有的話，從 cache 拿，
   * 沒有的話，打 API 並存入 cache
   */
  getTotalPaginationBestsellers = async (count = 3) => {
    const {
      pagination = {},
      term = 30,
      sortType,
      customRange,
      changeCustomTab,
      useSearch
    } = this.state
    const stockStatus = this.getStockFormValues()
    const activeStatus = this.getActiveFormValues()

    const formatDate = changeCustomTab
      ? getRangeAPIDate(customRange)
      : getRangeAPIDate(getRangeByTerm(term))

    const rowLimit = 50
    const { resultsTotal } = pagination
    const currentResultTotal = resultsTotal > 1000 ? 1000 : resultsTotal

    const expectTotalPages = currentResultTotal / rowLimit
    // 不是整數代表有餘數需要 +1 才能取得全部資料
    const totalPages = Number.isInteger(expectTotalPages)
      ? expectTotalPages
      : _.floor(expectTotalPages) + 1
    const pendingData = []
    for (let i = 0; i < totalPages; i++) {
      const page = i + 1

      const cacheDataObj = {
        sortType,
        term,
        page,
        isExport: true,
        isZeroStock: stockStatus,
        isActive: activeStatus
      }
      // 自訂區間需要帶 reportDate, 否則不同時間的資料會拿錯
      if (changeCustomTab && useSearch) {
        cacheDataObj.term = customRangeName
        cacheDataObj.reportDate = formatDate
      }
      const cacheData = this.getSpecificCacheData(cacheDataObj)

      const apiPayloadObj = {
        page,
        sortType,
        isExport: true,
        reportDate: formatDate, // term 只有購中使用，se 一率轉成 reportDate
        ...(stockStatus && { stock: 0 }),
        ...(activeStatus && { isActive: true })
      }
      if (cacheData) {
        pendingData.push(Promise.resolve(cacheData))
      } else {
        const bestsellers = this.getSpecificPaginationBestsellers(apiPayloadObj)

        pendingData.push(bestsellers)
      }
    }

    try {
      const totalBestsellers = (await Promise.all(pendingData))
        .reduce((acc, cur) => acc.concat(cur.data), [])

      // 關閉 loading 畫面
      this.setIsSuccess(true)

      return [null, totalBestsellers]
    } catch (error) {
      if (count > 0) {
        return this.getTotalPaginationBestsellers(count - 1)
      }
      this.setIsSuccess(true)
      return [error, []]
    }
  }

  /** Override BaseModule loading to disable it */
  renderLoading () {
    return null
  }

  render () {
    const {
      withPagination,
      rowLimit = 5/* 50 */,
      className,
      title = '',
      disableMoreLink,
      onGaClick
    } = this.props

    const {
      columns,
      pagination = {},
      page,
      term,
      data,
      isLoading,
      periodText,
      isError,
      changeCustomTab,
      customRange
    } = this.state

    const { resultsTotal } = pagination

    const clz = cx(
      styles.Bestseller,
      {
        [className]: !!className
      })

    return (
      <div
        data-role='saleStat-bestseller'
        className={clz}
      >
        <Loader loaded={!isLoading}>
          {
            isError
              ? this.renderIOError()
              : (
                <>
                  <h2 className={styles.bestsellerTitle}>
                    {title}
                  </h2>
                  <RadioGroup
                    defaultValue={term}
                    data-role='bestseller-term--select'
                    options={BESTSELLER_TERM_OPTIONS}
                    onChange={this.onTermRadioChange}
                  />
                  {changeCustomTab
                    ? (
                      <Block
                        key='searchForm'
                      >
                        <SearchForm
                          customRange={customRange}
                          onFormInit={this.setSearchFormProps}
                          onSubmit={this.onSearch}
                          onlineDate={SELLER_DASHBOARD_ONLINE_DATE}
                          isSeller
                        />
                      </Block>
                    )
                    : (
                      <div className={styles.optionsRow}>
                        <span className={styles.period}>
                          {`資料統計區間: ${periodText}`}
                        </span>
                      </div>
                    )}
                  <When
                    value={resultsTotal > 0}
                    isTrue
                  >
                    <div className={styles.sortTab}>
                      {`共${resultsTotal}筆，每頁${rowLimit}筆`}
                      {this.generateSortByRadio()}
                    </div>
                  </When>
                  <section className={styles.bestsellerCard}>
                    <YTable
                      sortable={false}
                      resizable={false}
                      showPagination={false}
                      data={data}
                      noDataText='該訂購區間無銷售紀錄'
                      columns={columns}
                      pageSize={rowLimit}
                    />
                    <When
                      value={!disableMoreLink}
                      isTrue
                    >
                      <section className={styles.tableFooter}>
                        <a
                          href='/seller/items/bestsellerRanking'
                          onClick={() => onGaClick('s_topsell_moreitems')}
                        >
                          看更多排行
                          <Icon
                            color={'#5478fc'}
                            name={'caret-right'}
                            size={14}
                          />
                        </a>
                      </section>
                    </When>

                  </section>
                </>
              )
          }
        </Loader>
        {/* table 分頁 */}
        <When
          value={withPagination && resultsTotal > 0}
          isTrue
        >
          <BestsellerPagination
            total={resultsTotal}
            current={page}
            defaultPageSize={rowLimit}
            onChange={this.onPageChange}
          />
        </When>
      </div>
    )
  }
}

export default formDecorator(CONFIG)(Bestseller)
